<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش گروه‌بندی"
    dialogId="update-lesson-category-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="updateLessonCategory"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="lessonCategoryPayloadTitle"
        inputLabel="عنوان گروه‌بندی درس"
        inputPlaceholder="مقدماتی..."
        v-model="updateLessonCategoryPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|between:0,100"
        type="number"
        inputId="lessonCategoryPayloadPercent"
        inputLabel="درصد تخفیف گروه‌بندی"
        inputPlaceholder="10"
        v-model="updateLessonCategoryPayload.discountPercent"
      >
        <template #append> % </template>
      </TextInput>
    </BCol>
    <BCol cols="12">
      <IndependentLessonPicker
        :defaultLessonId="updateLessonCategoryPayload.lessonIds"
        is-in-dialog
        is-multiple
        @getLesson="setLessons"
      ></IndependentLessonPicker>
    </BCol>
    <BCol cols="12">
      <SupportPackagePicker
        :defaultCounselingPackageId="
          updateLessonCategoryPayload.counselingPackageId
        "
        @getSupportPackage="setSupportPackage"
      ></SupportPackagePicker>
    </BCol>
    <BCol cols="12">
      <BFormCheckbox
        v-model="updateLessonCategoryPayload.requirementForSupport"
        name="check-button"
        switch
      >
        <small style="margin-left: 3px"> آیا پیشنیاز پشتیبانی است؟ </small>

        <b
          >({{
            updateLessonCategoryPayload.requirementForSupport ? "بله" : "خیر"
          }})</b
        >
      </BFormCheckbox>
    </BCol>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultLessonCategoryId: {
      type: [String, Number],
      required: false,
    },
  },
  watch: {
    defaultLessonCategoryId: {
      handler(val) {
        if (val) {
          this.getLessonCategoryDetails();
        }
      },
    },
  },
  data() {
    return {
      updateLessonCategoryPayload: {
        id: null,
        title: null,
        discountPercent: null,
        requirementForSupport: null,
        lessonIds: [],
        counselingPackageId: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async getLessonCategoryDetails() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let getLessonCategoryById = new GetLessonCategoryById(_this);
        getLessonCategoryById.setRequestParam({
          id: _this.defaultLessonCategoryId,
        });
        await getLessonCategoryById.fetch((res) => {
          _this.updateLessonCategoryPayload = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    async updateLessonCategory() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateALessonCategory = new UpdateALessonCategory(_this);
        updateALessonCategory.setRequestParamDataObj(
          _this.updateLessonCategoryPayload
        );
        await updateALessonCategory.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "گروه‌بندی درس با موفقیت ویرایش شد.",
              },
            });
            _this.updateLessonCategoryPayload = {
              id: null,
              title: null,
              discountPercent: null,
              requirementForSupport: null,
              lessonIds: [],
              counselingPackageId: null,
            };
            this.$bvModal.hide("update-lesson-category-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    setLessons(lessonIds) {
      this.updateLessonCategoryPayload.lessonIds = lessonIds;
    },
    setSupportPackage(counselingPackageId) {
      this.updateLessonCategoryPayload.counselingPackageId =
        counselingPackageId;
    },
  },
  components: {
    CustomUpdateDialog,
    IndependentLessonPicker,
    BCol,
    BFormCheckbox,
    TextInput,
    SupportPackagePicker,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol, BFormCheckbox } from "bootstrap-vue";
import SupportPackagePicker from "@/views/components/LessonCategories/SupportPackagePicker.vue";
import {
  UpdateALessonCategory,
  GetLessonCategoryById,
} from "@/libs/Api/LessonCategory";
</script>
